<template>
  <v-dialog v-model="dialog" scrollable max-width="1000">
    <template #activator="{ on, attrs }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-icon>
          <v-icon>mdi-format-list-bulleted</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ $t("management-balances-list") }}
        </v-list-item-title>
      </v-list-item>
    </template>
    <v-card>
      <v-card-title class="techBlue white--text">
        {{ $t("management-balances-list") }}
        <v-spacer />
        <v-text-field
          v-model="managementBalanceTableSearch"
          :label="$t('search')"
          solo
          dense
          color="white"
          hide-details
        />
      </v-card-title>
      <v-card-text class="pt-5">
        <v-data-table
          :headers="headers"
          :items="allManagementBalances"
          item-key="id"
          :search="managementBalanceTableSearch"
        >
          <template #[`item.id`]="{ item }">
            {{ item.id }}
          </template>
          <template #[`item.createdAt`]="{ item }">
            {{ Formatters.formatDateAndHour(item.createdAt) }}
          </template>
          <template #[`item.action`]="{ item }">
            <ActionMenu :items="getActionItems(item)" :context="item" dense />
          </template>
        </v-data-table>
        <v-dialog v-model="deleteDialog" max-width="600">
          <v-card>
            <v-card-title class="error white--text">
              {{ $t("delete-management-balance-title") }}
            </v-card-title>
            <v-card-text class="pt-5">
              {{ $t("delete-management-balance-warning") }}
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn plain @click="deleteDialog = false">
                {{ $t("close") }}
              </v-btn>
              <v-btn color="error" dark @click="onConfirmDelete">
                {{ $t("confirm") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn plain @click="dialog = false">{{ $t("close") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { Formatters } from "@/utilities/formatters.js";
import { ManagementBalanceService } from "@/services";
import { showErrorSnackbar } from "@/utilities/snackbar";
import ActionMenu from "@/components/common/ActionMenu.vue";

export default {
  name: "ManagementBalancesListDialog",
  components: {
    ActionMenu,
  },
  data() {
    return {
      dialog: false,

      managementBalanceTableSearch: "",
      allManagementBalances: [],
      deleteDialog: false,

      toBeDeletedId: null,

      Formatters,
    };
  },
  computed: {
    ...mapGetters({
      businessPlan: "businessPlan/getBusinessPlan",
      businessPlanReady: "businessPlan/isReady",
    }),
    businessPlanId() {
      return this.businessPlanReady ? this.businessPlan.id : null;
    },
    headers() {
      return [
        {
          text: this.$t("id"),
          align: "start",
          sortable: false,
          value: "id",
        },
        {
          text: this.$t("name"),
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: this.$t("created-at"),
          align: "center",
          sortable: false,
          value: "createdAt",
        },
        {
          text: this.$t("actions"),
          align: "end",
          sortable: false,
          value: "action",
        },
      ];
    },
  },
  async created() {
    try {
      await this.fetchData();
    } catch (ex) {
      showErrorSnackbar(undefined, ex, "business-plans");
    }
  },
  methods: {
    async fetchData() {
      if (this.businessPlanReady && this.businessPlan) {
        this.allManagementBalances = this.businessPlan.managementBalances;
      }
    },
    async deleteManagementBalance(id) {
      try {
        await ManagementBalanceService.remove(id);
      } finally {
        await this.fetchData();
      }
    },
    onDelete(id) {
      this.toBeDeletedId = id;
      this.deleteDialog = true;
    },
    async onConfirmDelete() {
      this.deleteDialog = false;
      await this.deleteManagementBalance(this.toBeDeletedId);
      const managementBalanceIndexToDelete =
        this.allManagementBalances.findIndex((managementBalance) => {
          return managementBalance.id === this.toBeDeletedId;
        });
      this.allManagementBalances.splice(managementBalanceIndexToDelete, 1);
      this.toBeDeletedId = null;
    },
    getActionItems(item) {
      return [
        {
          icon: "mdi-pencil-outline",
          label: "edit",
          color: "techBlueDark",
          callback: () =>
            this.$router.push({
              name: "balances.management.edit",
              params: { managementBalanceId: item.id },
            }),
        },
        {
          icon: "mdi-trash-can-outline",
          label: "delete",
          color: "error",
          callback: () => this.onDelete(item.id),
          divider: true,
        },
      ];
    },
  },
};
</script>
